import { composeSchema, createMarkdownRteEditor } from '@refract-cms/core';
import Icon from '@material-ui/icons/Dashboard';

export const HomeSchema = composeSchema({
  options: {
    alias: 'home',
    displayName: 'Home',
    icon: Icon,
    maxOne: true,
    mongoCollectionName: 'home',
  },
  properties: {
    textSection1: {
      type: String,
      displayName: 'Text section 1',
      editorComponent: createMarkdownRteEditor(),
    },
    textSection2: {
      type: String,
      displayName: 'Text section 2',
      editorComponent: createMarkdownRteEditor(),
    },
    // textSection3: {
    //   type: String,
    //   displayName: 'Text section 3',
    //   editorComponent: createMarkdownRteEditor(),
    // },
  },
});
